import { useContext } from 'react';

import { accountStateOf } from '@/auth/accountState';
import {
  getHomeDestination,
  type HomeDestination,
  PUBLIC_HOME,
} from '@/config/navigation';
import { AuthContext } from '@/hooks/authContext';

/**
 * Where a recovery screen sends the viewer: their own home, named the way the
 * nav names it ("My Classes", "Tasks"), once the server has confirmed their
 * role. Anyone else, or a screen rendered outside the auth provider (the
 * outermost crash boundaries), gets the public home page.
 */
export function useHomeDestination(): HomeDestination {
  const auth = useContext(AuthContext);
  if (!auth?.isAuthenticated) return PUBLIC_HOME;
  const state = accountStateOf({
    isRoleLoaded: auth.isRoleLoaded,
    userStatus: auth.userStatus,
    authError: auth.authError ?? null,
  });
  return state === 'active'
    ? getHomeDestination(auth.userRole, auth.user)
    : PUBLIC_HOME;
}
